import { Box } from '@factorialco/deprecated-design-system'

import UpdatesWithCEOHeader from 'modules/product_updates/components/UpdatesWithCEOHeader'
import UpdatesWithCEOList from 'modules/product_updates/components/UpdatesWithCEOList'

const Content = () => {
  return (
    <Box paddingBottom="s80">
      <UpdatesWithCEOHeader />
      <UpdatesWithCEOList />
    </Box>
  )
}

export default Content
